import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class ToggleButton extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        arrows: PropTypes.bool,
        border: PropTypes.number,
        disabled: PropTypes.bool,
        height: PropTypes.number,
        inactiveGreyBackground: PropTypes.bool,
        inactiveGreyBorder: PropTypes.bool,
        onClickHandler: PropTypes.func,
        padding: PropTypes.number,
        textOff: PropTypes.string,
        textOn: PropTypes.string,
    }

    static defaultProps = {
        arrows: false,
        border: 2,
        height: 12,
        disabled: false,
        inactiveGreyBackground: false,
        inactiveGreyBorder: false,
        onClickHandler: () => {},
        padding: 2,
        textOff: 'Off',
        textOn: 'On',
    }

    onClick = () => {
        const { active, onClickHandler } = this.props

        onClickHandler(!active)
    }

    render() {
        const {
            active,
            arrows,
            textOn,
            textOff,
            height,
            border,
            padding,
            inactiveGreyBackground,
            inactiveGreyBorder,
            disabled,
        } = this.props

        const valueOn = arrows ? <div className={cx('arrow', 'on')} /> : textOn
        const valueOff = arrows ? <div className={cx('arrow', 'off')} /> : textOff

        return (
            <div
                className={cx(
                    'toggle-switch-button',
                    active && !disabled && 'active',
                    inactiveGreyBackground && 'greyBackground',
                    inactiveGreyBorder && 'greyBorder',
                    disabled && 'disabled'
                )}
                style={{
                    height: `${height + 2 * padding}px`,
                    // The original (for some reason): borderRadius: `${(height + (2 * border) + (2 * padding)) / 2}px / 50%`
                    borderRadius: `${(height + 2 * border + 2 * padding) / 2}px`,
                    padding: `${padding}px`,
                    borderWidth: `${border}px`,
                }}
                onClick={this.onClick}
            >
                <div
                    className={cx('toggle-switch-button-text', arrows && 'arrows')}
                    style={{
                        height: `${height}px`,
                        // The original (for some reason): borderRadius: `${height / 2}px / 50%`
                        borderRadius: `${height / 2}px`,
                    }}
                >
                    <div className={'toggle-switch-button-width'}>
                        <div>{valueOn}</div>
                        <div>{valueOff}</div>
                    </div>
                    <div className={cx('toggle-switch-button-text-value')}>
                        <div className={'toggle-switch-button-text-value-on'}>{valueOn}</div>
                        <div className={'toggle-switch-button-text-value-off'}>{valueOff}</div>
                    </div>
                </div>
            </div>
        )
    }
}
